import { Component,Renderer2, OnInit ,ViewEncapsulation, AfterViewInit, OnDestroy,ViewChild, ElementRef } from '@angular/core';
 
import {Observable, pipe, throwError, Subscription} from 'rxjs'; 
// import { Res,IProfile } from 'src/app/entity';

import { ToastrService } from 'ngx-toastr';

import { Router,ActivatedRoute } from '@angular/router';


import {NewsletterService} from '../services/newsletter.service';

import {HomeService} from '../services/home.service';

import {ArticleService} from '../services/article.service'

import {MessageService} from '../message.service';

import {BaseComponent} from '../dashboard/base/base.component';

import {IRule} from '../irule';

import {AppSettings} from '../settings';

declare var $: any;

@Component({
  selector: 'newsletterview',
  // encapsulation: ViewEncapsulation.None,
  templateUrl: './NewsletterView.component.html',
  styles: ['./news.css']
})
export class NewsletterViewComponent  {
  
  
   @ViewChild('temp1' ,{static: true})   temp1: ElementRef;
   @ViewChild('temp2' ,{static: false})   temp2: ElementRef;
   @ViewChild('temp3' ,{static: false})   temp3: ElementRef;
   
    newsletterid:number=0;
    token:any;
    sections:Array<any>=[];
    sectionData:Array<any>=[];
    bannerImage:any ;
    url:any=AppSettings.API_ENDPOINT;
    header:any;
    footer:any;


    constructor( private route: ActivatedRoute,homeservice:HomeService,_router: Router,private newsService:NewsletterService , toastr: ToastrService,msg:MessageService,private articleService:ArticleService,private renderer: Renderer2){
    
               
      this.newsletterid = +this.route.snapshot.paramMap.get('id');
      this.token = this.route.snapshot.paramMap.get('token')
     

      try{


        // let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
        // if(!tokenA) throw 'Error in parse';
        
        // if(!JSON.parse(tokenA)) throw 'Error in json parse';
      
        // tokenA = JSON.parse(tokenA);
  

        if(this.newsletterid && this.token){


          let data={
            token:this.token,
            id:this.newsletterid
          }


            this.newsService.newsletterDataById(data).subscribe( (elem)=>{

        
              if(elem.newsletter){

                msg.sendMessage({'type':'open_layout_user','user':elem.user});

               if(elem.newsletter[0] && elem.newsletter[0].sections!=null){

                this.bannerImage=elem.newsletter[0].sections.bannerImage;
                this.sections=elem.newsletter[0].sections;
                this.sectionData=elem.newsletter[0].sections.sectionData;
                this.header =elem.newsletter[0].sections.header;
                this.footer = elem.newsletter[0].sections.footer;

                
                this.sectionData.map((x,i)=>{

                  let fullBorderCss={}
                  let fullBorderCssTd={}
                  let lastfullBorderCss={}
                  // let rightBorderCss ={}

                   if(x.fullBorder==true){

                    fullBorderCss['border'] ="1px solid"
                    fullBorderCss['border-color'] = x.fullBorderCss.style['border-color']
                    fullBorderCssTd['padding'] ="5px"
                    lastfullBorderCss['margin-right'] = "0"
                    lastfullBorderCss['border'] ="1px solid"
                   
                    //fullBorderCssTd['border-color'] ="black";
                      
                   }

                   if(x.rightBorder==true){

                    fullBorderCss['border-right'] ="2px solid"
                    fullBorderCss['width'] ="280px"
                    fullBorderCss['border-color'] = x.rightBorderCss.style['border-color']
                    fullBorderCss['margin-right'] ="0"
                    fullBorderCssTd['margin-right'] ="0"
                    fullBorderCssTd['padding-left'] ="15px"
                    fullBorderCssTd['padding-right'] ="15px"
                    lastfullBorderCss['margin-right'] = "0"
                    lastfullBorderCss['border'] ="0"
                    lastfullBorderCss['width'] ="280px"
                   
                   
                  }

                  if(x.backgroundCss.style['background-color']!='none'){

                    x.backgroundCss.style['padding-top'] = '15px'
                    x.backgroundCss.style['padding-bottom'] = '15px'

                  }
                
                  if(x.isDividerOn==true && x.layout ==1){
                    x.dividerCss.style['margin-bottom']= '30px'

                  }

                 

                  // if(x.isDividerOn==true){

                  //   this.sectionData[i].backgroundCss.style['border-bottom']='3px solid #000'
                  // }

                   this.sectionData[i].fullBorderCss = fullBorderCss;
                   this.sectionData[i].fullBorderCssTd = fullBorderCssTd;
                   //this.sectionData[i].rightBorderCss = rightBorderCss;
                   this.sectionData[i].lastfullBorderCss = lastfullBorderCss

                })
                
              

               }

                

              }else{
                toastr.error('Newsletter Not Found  !', '', {timeOut: 3000});
                // _router.navigate(['/login']);
              }
          
            });
      

          }



      }catch(Exc ){
        
        toastr.error('Invalid Token  !', '', {timeOut: 3000});

        // _router.navigate(['/login']);
      }
 
    }

    setMyStyles(val) {

     

      let ht =  val.navObject.descriptionCss.fontSize.replace('px','') -15 +'px';

 

      let style={
        height:'0px'
      }
  
     if(val.navObject.descriptionCss!=undefined && val.navObject.descriptionCss.fontSize!=undefined){
  
       style={
        height: ht 
      }
  
     }
     return style
   }


   
   ngAfterViewInit() {

    // let h1 = this.temp1.nativeElement.offsetHeight;
    // let h2 = this.temp1.nativeElement.offsetHeight;
    // let h3 = this.temp1.nativeElement.offsetHeight;
   
   
   
 
   

    
      
    
   }


 


 

}
